import * as React from "react";
import moment from "moment";
import "./style.scss";
import { utils } from "../../../common";
import Section from "../../../core/Section";
import Table from "../../../core/Table";
import Button from "../../../core/Button";
import { Link, withRouter } from "react-router-dom";
import FileStatus from "./FileStatus";
import { ViewReportFileProps, ViewReportFileActions } from "./container";
import { ReportFile, ReportFileStatus } from "../../constants";
import Feature from "../../../common/components/Feature";

const STATUS_TO_VALUE: any = {
  failure: -1,
  pending: 0,
  success: 1,
  system_failure: -2
};

const REPORT_FILE_COLUMNS = [
  {
    title: "Export Status",
    dataIndex: "report_status",
    key: "report_status",
    sorter: (a: any, b: any) =>
      STATUS_TO_VALUE[a.status] - STATUS_TO_VALUE[b.status],
    width: 190
  },
  {
    title: "Date/Time Sent",
    dataIndex: "scheduled_on",
    key: "scheduled_on",
    sorter: (a: any, b: any) =>
      Date.parse(a.scheduled_on || 0) - Date.parse(b.scheduled_on || 0),
    width: 130
  },
  {
    title: "File Name",
    dataIndex: "filename",
    key: "filename",
    sorter: (a: any, b: any) => a.filename.localeCompare(b.filename)
  },
  {
    title: "Report",
    dataIndex: "report_link",
    key: "report_link",
    width: 80
  },
  {
    title: "Resend Report",
    dataIndex: "resend_button",
    key: "resend_button",
    width: 100
  },
  {
    title: "Download Report",
    dataIndex: "download_report",
    key: "download_report",
    width: 120
  }
];

class ViewReportFiles extends React.Component<
  ViewReportFileProps & ViewReportFileActions,
  {}
> {
  handleReportFileDownload(
    merchant_id: number,
    report_id: number,
    report_file_id: number
  ) {
    utils.download_resource(
      `/api/merchants/${merchant_id}/reports/${report_id}/files/${report_file_id}/download`
    );
  }

  componentWillMount() {
    this.props.flushReportFiles();
    this.props.getReportFiles(this.props.match.params.merchant_id);
  }

  resendReportFile(
    report_id: number,
    report_file_id: number,
    filename: string
  ) {
    this.props.resendReportFile(
      this.props.match.params.merchant_id,
      report_id,
      report_file_id
    );
  }

  mapFilesToTableRows() {
    let merchantId = this.props.match.params.merchant_id;

    return this.props.files.map((file: ReportFile) => {
      let sentTime = moment(file.sent_time).format("YYYY-MM-DD @ HH:mm:ss");
      let scheduledOn = moment(file.scheduled_on).format(
        "YYYY-MM-DD @ HH:mm:ss"
      );
      let editLink = `/merchants/${merchantId}/reports/${file.report_id}/edit`;
      let queryStatus = file.report_statuses.find(
        (status: ReportFileStatus) => status.process == "query_runner"
      );

      return {
        key: file.id,
        status: file.status,
        report_status: <FileStatus reportFile={file} editLink={editLink} />,
        sent_time: file.sent_time === null ? "N/A" : sentTime,
        scheduled_on: file.scheduled_on === null ? "N/A" : scheduledOn,
        filename: file.filename === null ? "N/A" : file.filename,
        report_link: <Link to={editLink}>Edit Report</Link>,
        resend_button: (
          <Feature flag="apr_3_admin">
            <Button
              className="ant-btn-secondary resend-btn"
              disabled={file.status === "system_failure" || !file.enabled}
              onClick={this.resendReportFile.bind(
                this,
                file.report_id,
                file.id,
                file.filename
              )}
            >
              Resend
            </Button>
          </Feature>
        ),
        download_report: (
          <Feature flag="apr_3_admin">
            <Button
              className="download-btn"
              disabled={
                queryStatus.status !== "success" ||
                file.status === "system_failure" ||
                !file.enabled
              }
              type="primary"
              onClick={this.handleReportFileDownload.bind(
                this,
                merchantId,
                file.report_id,
                file.id
              )}
            >
              Download Report File
            </Button>
          </Feature>
        )
      };
    });
  }

  render() {
    return (
      <div className="view-report-files">
        <h1>View Report Files</h1>
        <Table
          size="middle"
          dataSource={this.mapFilesToTableRows()}
          columns={REPORT_FILE_COLUMNS}
        />
      </div>
    );
  }
}

export default withRouter(ViewReportFiles as any);



// WEBPACK FOOTER //
// ./client/modules/Report/components/ViewReportFiles/component.tsx